export const legacyGinActionRoute = {
	name: 'legacy-gin-action',
	path: '/secure/IssueNavAction!default.jspa',
	query: ['filter|jql|issueKey'],
};
